import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import NotesAndQueriesList from "@/components/lists/notes/NotesAndQueriesList";
import CoordinatingGroupContext from "@/contexts/data/CoordinatingGroupContext";
import InstitutionContext from "@/contexts/data/InstitutionContext";
import MasterGroupContext from "@/contexts/data/MasterGroupContext";
import ParticipantContext from "@/contexts/data/ParticipantContext";
import TrialContext from "@/contexts/data/TrialContext";
import { NotesAndQueriesInstitutionCreateLink, NotesAndQueriesParticipantCreateLink, NotesAndQueriesTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useInstitutionNotesAndQueries from "@/hooks/data/useInstitutionNotesAndQueries";
import useParticipantNotesAndQueries from "@/hooks/data/useParticipantNotesAndQueries";
import { Typography } from "@mui/material";
import { FC, useContext } from "react";

const ParticipantNotesAndQueries: FC = () => {
    const { data: trial } = useContext(TrialContext);
    const { data: masterGroup } = useContext(MasterGroupContext);
    const { data: coordinatingGroup } = useContext(CoordinatingGroupContext);
    const { data: institution } = useContext(InstitutionContext);
    const { data: participant } = useContext(ParticipantContext);
    const { data: notes, loading: notesLoading, validating: notesValidating } = useParticipantNotesAndQueries(participant?.id, { revalidateOnFocus: false });


    const loading = notesLoading;
    const validating = notesValidating;

    return (
        <>
            <SetLinks 
                createTrialLink={NotesAndQueriesTrialCreateLink} 
                createInstitutionLink={NotesAndQueriesInstitutionCreateLink} 
                createParticipantLink={NotesAndQueriesParticipantCreateLink}  
            />
            <IsLoading name="participant-notes-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Notes And Queries
                </Typography>
                <NotesAndQueriesList 
                    trialId={trial?.id} 
                    masterGroupId={masterGroup?.id}
                    coordinatingGroupId={coordinatingGroup?.id}
                    institutionId={institution?.id}
                    participantId={participant?.id}
                    notesAndQueries={notes} 
                />
            </Show>
        </>
    )
};

export default ParticipantNotesAndQueries;